import { Popups } from 'ui/types/popups';
import { GAEvent, GAEventNames } from './analytics/events';
import { EventName } from './events/eventsName';
import { GameEvent } from './events/gameEvent';
import { GameUI } from './gameUI/GameUI';
import { Store } from './store/gameStore';
let place = 'win' as 'win' | 'button';

GameEvent.add(EventName.CLOSE_MODAL, onCloseModal);

addEventListener('feedbackError', () => {
    GameUI.showPopup(Popups.KING_POPUP, { textKey: 'feedbackError', isNotification: true });
    GAEvent(GAEventNames.FEEDBACK_ERROR, {
        number: Store.feedbackCounterShown,
        type: Store.getGameTypeText(),
        difficulty: Store.getDifficultyText(),
        trigger: place,
    });
});
addEventListener('feedbackSuccess', () => {
    GameUI.showPopup(Popups.KING_POPUP, { textKey: 'feedbackThankYou', isNotification: true });
    Store.blockFeedbackOnWin();
    GAEvent(GAEventNames.FEEDBACK_SEND, {
        number: Store.feedbackCounterShown,
        type: Store.getGameTypeText(),
        difficulty: Store.getDifficultyText(),
        trigger: place,
    });
});
export function openFeedbackPopup(newPlace: 'win' | 'button') {
    place = newPlace;
    Store.pauseGame();
    GameUI.showPopup(Popups.FEEDBACK_POPUP);
    GAEvent(GAEventNames.FEEDBACK_SHOW, {
        number: Store.feedbackCounterShown,
        type: Store.getGameTypeText(),
        difficulty: Store.getDifficultyText(),
        trigger: newPlace,
    });
}
function onCloseModal({ id, confirm }: { id: string; confirm: boolean }) {
    switch (id) {
        case 'feedback':
            window.scrollTo(0, 0);
            if (!confirm) {
                GAEvent(GAEventNames.FEEDBACK_NOT_NOW, {
                    number: Store.feedbackCounterShown,
                    type: Store.getGameTypeText(),
                    difficulty: Store.getDifficultyText(),
                    trigger: place,
                });
            }
            if (place === 'win') {
                GameEvent.emit(EventName.SHOW_WIN_AFTER_FEEDBACK);
            } else {
                Store.resumeGame();
            }
            break;
    }
}
